// extracted by mini-css-extract-plugin
export default {"listaEquipsVisualizar":"ListaEquipamento_listaEquipsVisualizar__TqgPa","listaParcipantesDelete":"ListaEquipamento_listaParcipantesDelete__dA0Ci"};